import TotalCost from './TotalCost.component';
export default TotalCost;